<svg
  *ngIf="hasData(); else zeroState"
  xmlns="http://www.w3.org/2000/svg"
  (clientSize)="svgSize = $event"
  (mouseleave)="onLeave()"
  (mousemove)="onLeave()"
>
  <ng-container *ngIf="svgSize.width > 1 && getXScale() && getYScale()">
    <rect
      *ngIf="shouldAddHorizontalOffset()"
      class="tick"
      [attr.x]="64"
      y="0"
      width="1"
      [attr.height]="minZero(getYScale()(0))"
    ></rect>
    <g *ngFor="let tick of getXTicks()">
      <rect
        class="tick"
        [attr.x]="getXScale()(tick)"
        y="0"
        width="1"
        [attr.height]="minZero(getYScale()(0))"
      ></rect>
      <text
        class="x-tick-label"
        [attr.x]="getXScale()(tick)"
        [attr.y]="getYScale()(0)"
        dy="16"
      >
        {{ getDateRange(tick) }}
      </text>
    </g>
    <g *ngFor="let tick of getYTicks()">
      <rect
        class="tick"
        x="0"
        [attr.y]="getYScale()(tick)"
        width="100%"
        height="1"
      ></rect>
      <text class="y-tick-label" x="0" [attr.y]="getYScale()(tick)" dy="-4">
        {{ valueFormatter(tick) }}
      </text>
    </g>
    <g
      *ngFor="let bar of getBars()"
      (mouseover)="setYHoverable($event); onHover(bar)"
    >
      <rect
        class="bar"
        *ngFor="let v of bar.values; let i = index"
        [attr.data-index]="i"
        [attr.x]="bar.x"
        [attr.y]="bar.yArr[i]"
        [attr.width]="minZero(bar.w)"
        [attr.height]="minZero(bar.hArr[i])"
        [style.fill]="keyLegend[bar.values.length - i - 1].color"
      ></rect>
    </g>
  </ng-container>
</svg>
<div class="rv-flex flex-end">
  <div class="bar-graph-legend">
    <div class="bar-graph-legend-entry" *ngFor="let k of keyLegend">
      <div
        class="bar-graph-legend-color-tile"
        [style.background-color]="k.color"
      ></div>
      {{ k.key }}
    </div>
  </div>
  <ng-content></ng-content>
</div>
<div *ngIf="currentHoverable">
  <deprecated-callout
    *deprecated-callout
    [isModal]="false"
    [anchor]="calloutAnchor"
    style="pointer-events: none"
    [preferredPosition]="AnchoredPosition.CENTER_RIGHT"
    fallbackDirection="cw"
  >
    <div class="hover">
      <p>
        {{ getTooltipTitle(currentHoverable.dateMoment) }}
      </p>
      <p
        class="rv-stat-small"
        class="labels"
        *ngFor="let v of currentHoverable.values; let i = index"
      >
        <ng-container *ngIf="currentHoverable.values.length == 0">
          No data
        </ng-container>
        <ng-container *ngIf="currentHoverable.values.length != 0">
          <span
            class="symbol"
            [style.background-color]="
              keyLegend[currentHoverable.values.length - i - 1].color
            "
          ></span>
          {{ getIndTooltip(currentHoverable, i) }}
        </ng-container>
      </p>
    </div>
  </deprecated-callout>
</div>

<ng-template #zeroState>
  <div class="zero-state">No data to display.</div>
</ng-template>
